import React from 'react';
import { useTranslation } from 'react-i18next';
import './ViewToggle.css';

type Props = {
    showOnlyMine: boolean;
    onChange: (showOnlyMine: boolean) => void;
};

/** Switches the shared list between everything available and the items the therapist created. */
const OwnershipFilter = ({ showOnlyMine, onChange }: Props): JSX.Element => {
    const { t } = useTranslation();

    return (
        <div className="frontpage__view-toggle" role="group" aria-label={t('Filter by creator')}>
            <button
                type="button"
                className={`frontpage__toggle-button ${!showOnlyMine ? 'active' : ''}`}
                aria-pressed={!showOnlyMine}
                onClick={() => onChange(false)}
            >
                {t('All')}
            </button>
            <button
                type="button"
                className={`frontpage__toggle-button ${showOnlyMine ? 'active' : ''}`}
                aria-pressed={showOnlyMine}
                onClick={() => onChange(true)}
            >
                {t('Created by me')}
            </button>
        </div>
    );
};

export default OwnershipFilter;
